import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { BreadcrumbService } from "./breadcrumb.service";
import { BrokerService } from "./broker.service";

export interface Link {
  text?: string;
  routeData?: any[];
}

export interface ViewData {
  pageTitle?: string;
  link?: Link;
  breadcrumbs?: boolean;
}

@Injectable()
export class ViewService {
  constructor(
    public router: Router,
    public location: Location,
    public breadcrumbs: BreadcrumbService,
    public broker: BrokerService
  ) {}

  setViewData(data: ViewData) {
    this.broker.broadcast("view.service.changed", data);
  }

  routerLink(params: any[]) {
    return this.breadcrumbs.routerLinkFromLast(params);
  }

  routerLinkReplacingParams(params: any) {
    return this.breadcrumbs.routerLinkFromLastReplacingParams(params);
  }

  back() {
    if (this.breadcrumbs.breadcrumbs.length > 0) {
      if (this.breadcrumbs.breadcrumbs.length == 1)
        this.router.navigate(this.breadcrumbs.breadcrumbs[0].routeLink);
      else this.location.back();
    } else {
      this.router.navigate(["/"]);
    }
  }
}
